import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../../Components/PageTitle';
import { NoRecords } from '../../../Components/Shimmer';
import { ConfigContext } from '../../../Context/ConfigContext';
import Select from 'react-select'
import axios from "axios";
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
// import * as XLSX from 'xlsx-style';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { currentDateAndTime,decodeData } from '../../../Constants/constants';
import { useLocation } from 'react-router-dom';

const ComplianceReports = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON ,permissions,setPermissions} = useContext(ConfigContext);
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");
     const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [rows, setRows] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [loadingList, setLoadingList] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingPayroll, setLoadingPayroll] = useState(false);
    const [processExcelExportModal, setProcessExcelExportModal] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [department, setDepartment] = useState([]);
    const [location, setLocation] = useState([]);
    const [complianceReportType, setComplianceReportType] = useState("");
    const [uploadProgress, setUploadProgress] = useState(0);
    // const []
    const [filter, setFilter] = useState({
        keyword: null,
        month: null,
        attendanceMonth: null,
        location: null,
        department: null,
    });
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false
    });
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const complianceReportOption=[
        {value:"PT", label:"PT Report"},
        {value:"LWF", label:"LWF Report"},
        {value:"ESIC", label:"ESIC Report"},
        {value:"PF", label:"PF Report"},
    ];

    const getList = () => {
        // console.log(`pagination?.limit,pagination?.page`,pagination?.limit,pagination?.page);
        const headers = apiHeaderJSON;
        // console.log("filter?.month", filter?.month);
        axios
            .get(`${apiURL}Payrolls/GetEmployeesListForPtLwfReports`, {
                params: {
                    limit: pagination?.limit || 10,
                    page: pagination?.page || 1,
                    keyword: filter?.keyword,
                    month_year: filter?.month,
                    location_id: filter?.location,
                    department_id: filter?.department,
                },
                headers,
            })
            .then((response) => {
                const data = response?.data?.data;
                if (data?.success === true) {
                    // console.log(data);
                    setPagination({
                        ...pagination,
                        next: data?.next,
                        prev: data?.prev,
                        page: data?.page,
                        total_records: data?.total_records,
                        total_pages: data?.total_pages
                    });
                    setRows(data?.data);
                    

                } else {
                    setPagination({ ...pagination, loadingList: false });
                    // console.log(`data?.message`,response?.data)
                    if(response?.data?.message==="Month year selection is required."){
                        Swal.fire({
                            title: `<strong>Failed</strong>`,
                            text: response?.data?.message,
                            icon: 'error',
                            showConfirmButton: true,
                            allowOutsideClick:false,
                        });
                    }
                }
            }).catch((error)=>{
                console.log("ERROR", error);
            }).finally(()=>{
                setLoadingList(false);
                setLoadingFilter(false);
            });
    };

    const getMonthFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryRegisterMonthYearFilterData`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getMonthFilterList", data);
                if (data?.success === true) {
                    setMonthOptions(data?.filterData)
                } else {

                }
            });
    };


    const getDepartmentFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetDepartments`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getDepartmentFilterList", data);
                if (data?.success === true) {
                    let row = data?.departments?.map((val) => {
                        return { value: val?.department_id, label: val?.department_title }
                    })
                    // row?.splice(0, 0, { value: "All", label: "All" });
                    // let allDepartmentRow = data?.departments?.map((val) => {
                    //     return val?.department_id
                    // });
                    // allDepartmentRow = allDepartmentRow?.join(",");
                    setDepartment(row)


                } else {

                }
            });
    };
    const getLocationFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetLocations`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getLocationFilterList", data);
                if (data?.success === true) {
                    let row = data?.locations?.map((val) => {
                        return { value: val?.location_id, label: val?.location_title }
                    })
                    setLocation(row);


                } else {

                }
            });
    };
    useEffect(() => {
        getMonthFilterList();
        getDepartmentFilterList();
        getLocationFilterList();
    }, []);

    const handleMultiSelect = (fieldName, selectedOptions) => {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // console.log(ids.join(','))
        setFilter(prevFormData => ({
            ...prevFormData,
            [fieldName]: ids.join(',')
        }));
        // console.log("ids", ids);
        // if (!ids || ids?.length === 0) {
        //     setIsChanged(true);
        // }
    };

    const handleSlabChange = (index, fieldName, value) => {
        const updatedRows = [...rows];
        updatedRows[index] = {
            ...updatedRows[index],
            [fieldName]: value,
        };
        setRows(updatedRows);
    };

    const handleAttendance = () => {
        setLoadingExport(true);
        const headers = apiHeaderJSON;
        // console.log("filter?.month", filter?.month);
        axios
            .get(`${apiURL}Payrolls/RunAttendaceForPayroll`, {
                params: {
                    month: filter?.attendanceMonth,
                    date: currentDateAndTime(),
                },
                headers,
            })
            .then((response) => {
                var data = response?.data;
                if (data?.success === true) {
                    // console.log(data);
                    getMonthFilterList();
                    Swal.fire({
                        title: `<strong>${data?.success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: data?.success ? 'success' : 'error',
                        showConfirmButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {


                        }
                    });
                    setLoadingExport(false);

                } else {
                    Swal.fire({
                        title: `<strong>${data?.success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: data?.success ? 'success' : 'error',
                        showConfirmButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {

                        }
                    });
                    setLoadingExport(false);
                }
            }).catch((error) => {
                console.log(error);
                setLoadingExport(false);
            })
    };

    const handlePayroll = () => {
        
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to process payroll? And please check that Attendance and leave is locked.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
        }).then((result) => {
            if (result.isConfirmed) {
                setLoadingPayroll(true);
                let data = {
                    monthYear: filter?.month,
                    date: currentDateAndTime(),
                    employeeList: selectedRows
                }
                const headers = apiHeaderJSON;
                // console.log(data);
                axios
                    .post(`${apiURL}Payrolls/ProcessPayroll`, data, {
                        headers,
                        onUploadProgress: (progressEvent) => {
                            const { loaded, total } = progressEvent;
                            // console.log(`Loaded: ${loaded}, Total: ${total}`);
                            if (total) {
                              const percentCompleted = Math.round((loaded / total) * 90);
                            //   console.log(`Upload Progress: ${percentCompleted}%`);
                              setUploadProgress(percentCompleted);
                            } 
                          },
                        //   onUploadProgress: (progressEvent) => {
                        //     const { loaded, total } = progressEvent;
                        //     if (total) {
                        //       const percentCompleted = Math.round((loaded / total) * 100);
                        //       setUploadProgress(percentCompleted);
                        //     }
                        //   },
                    })
                    .then((response) => {
                        const { success } = response.data;
                        // console.log("handlePayroll ~ response =======>>>", response);
                        if (success === true) {
                            setUploadProgress(100);
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick:false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Optional: You can perform any action here after OK is clicked
                                    setSelectedRows([]);
                                    setLoadingPayroll(false);
                                    // setLoadingFilter(true);
                                    getList();
                                    setUploadProgress(0);
                                }
                            });

                        } else {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true,
                                allowOutsideClick:false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    setUploadProgress(0);
                                    // Optional: Action after the OK button is clicked
                                    // setLoadingPayroll(false);
                                }
                            });

                        }
                        setLoadingPayroll(false);
                    }).catch((e) => {
                        console.log(e);
                        setLoadingPayroll(false);
                    });
            }
            else {
                setLoadingPayroll(false);
            }
        })
    }

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((row) => {
                return { employee_id: row?.employee_id, employee_name: row?.employee_name, employee_code: row?.employee_code }
            }));
        } else {
            setSelectedRows([]);
        }
    };
    const handleInputChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        });
        if (!e.target.value) {
            setIsChanged(true);
        }
    };
    const handleCheckboxChange = (employeeData) => {
        const isSelected = selectedRows.some(row => row.employee_id === employeeData?.employee_id);
        if (isSelected) {
            setSelectedRows(selectedRows.filter(row => row.employee_id !== employeeData?.employee_id));
        } else {
            setSelectedRows([...selectedRows, {
                employee_id: employeeData?.employee_id,
                employee_name: employeeData?.employee_name,
                employee_code: employeeData?.employee_code,
            }]);
        }
    };

    // useEffect(() => {
    //     console.log("selectedRows", selectedRows);
    // }, [selectedRows]);


    // const handleExcelDownload = async () => {
    //     const headers = apiHeaderJSON;

    //     Swal.fire({
    //         title: 'Please wait...',
    //         html: 'Your file is being prepared for download.',
    //         allowOutsideClick: false,
    //         didOpen: () => {
    //             Swal.showLoading();
    //         }
    //     });

    //     const formData={
    //         month_year: filter?.month,
    //             department_id: filter?.department,
    //             location_id: filter?.location,
    //             employeeList: selectedRows
    //     }

    //     let url;
    //     if(complianceReportType==="PT"){
    //         url="Payrolls/GetPTReports"
    //     }
    //     else if(complianceReportType==="LWF"){
    //         url="Payrolls/GetLWFReports"
    //     }
    //     else if(complianceReportType==="ESIC"){
    //         url="Payrolls/GetESICReports"
    //     }

    //     axios.post(`${apiURL}${url}`, formData, {headers})
    //         .then(async (response) => {
    //             const { success, data, message, month, company_code } = response.data;
    //             // console.log("GetLWFReports Array",data);
    //             if (success === true) {
    //                 // Assuming `data` is an array of objects (representing rows of data)
    //                 const filteredData = data.slice(0); // Use this if you need to remove specific rows

    //                 // Explicitly set the headers based on the object keys (remove the index row)
    //                 const headers = Object.keys(filteredData[0]);

    //                 // Convert the filtered data to a worksheet without auto-indexing
    //                 const worksheet = XLSX.utils.json_to_sheet(filteredData, { skipHeader: true });

    //                 // Add background color to the header row and last row
    //                 const range = XLSX.utils.decode_range(worksheet["!ref"]);

    //                 // Apply style to the header row
    //                 for (let col = range.s.c; col <= range.e.c; col++) {
    //                     const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    //                     if (!worksheet[cellAddress]) continue;
    //                     worksheet[cellAddress].s = {
    //                     fill: { fgColor: { rgb: "FFFF00" } }, // Yellow background
    //                     font: { bold: true }, // Bold font
    //                     };
    //                 }

    //                 // Apply style to the last row
    //                 const lastRow = range.e.r;
    //                 for (let col = range.s.c; col <= range.e.c; col++) {
    //                     const cellAddress = XLSX.utils.encode_cell({ r: lastRow, c: col });
    //                     if (!worksheet[cellAddress]) continue;
    //                     worksheet[cellAddress].s = {
    //                     fill: { fgColor: { rgb: "FFC0CB" } }, // Light pink background
    //                     font: { bold: true }, // Bold font
    //                     };
    //                 }

    //                 // Create a new workbook and append the worksheet
    //                 const wb = XLSX.utils.book_new();
    //                 XLSX.utils.book_append_sheet(wb, worksheet, `${complianceReportType} Report`);

    //                 // Format the current date and time
    //                 const date = new Date();
    //                 const dateString = date.toLocaleDateString();

    //                 // Save the file with the correct format
    //                 XLSX.writeFile(wb, `${company_code} ${complianceReportType} Report ${month}.xlsx`);

    //                 Swal.close();
    //                 Swal.fire({
    //                     title: `<strong>Success</strong>`,
    //                     text: message,
    //                     icon: 'success',
    //                     showConfirmButton: true
    //                 });
    //             } else {
    //                 Swal.close();
    //                 Swal.fire({
    //                     title: `<strong>Failed</strong>`,
    //                     text: message,
    //                     icon: 'error',
    //                     showConfirmButton: true
    //                 });
    //             }
    //         })
    //         .catch((error) => {
    //             Swal.close();
    //             Swal.fire({
    //                 title: `<strong>Failed</strong>`,
    //                 text: error.response ? error.response.message : error.message,
    //                 icon: 'error',
    //                 showConfirmButton: true
    //             });
    //         }).finally(()=>{
    //             setLoadingExport(false);
    //         });
    // }
    const handleExcelDownload = async () => {
        const headers = apiHeaderJSON;
    
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    
        const formData = {
            month_year: filter?.month,
            department_id: filter?.department,
            location_id: filter?.location,
            employeeList: selectedRows,
            date: currentDateAndTime()
        };
    
        let url;
        if (complianceReportType === "PT") {
            url = "Payrolls/GetPTReports";
        } else if (complianceReportType === "LWF") {
            url = "Payrolls/GetLWFReports";
        } else if (complianceReportType === "ESIC") {
            url = "Payrolls/GetESICReports";
        } else if (complianceReportType === "PF") {
            url = "Payrolls/GetPFReports";
        }
    
        try {
            const response = await axios.post(`${apiURL}${url}`, formData, { headers });
            const { success, data, message, month, company_code } = response.data;
    
            if (success) {
                // Prepare the workbook and worksheet
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet(`${complianceReportType} Report`);
    
                // Skip adding headers to the Excel file
                const filteredData = data.map((row) => Object.values(row)); // Extract only row values
    
                // Add data rows directly without headers
                filteredData.forEach((rowData) => {
                    worksheet.addRow(rowData);
                });
    
                

                if(complianceReportType === "ESIC"){
                    worksheet.eachRow((row, rowNumber) => {
                        const rowValues = row.values.map(String); // Convert row values to strings for comparison
                     // Define a border style
                        const borderStyle = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' },
                        };
                        // Apply styles to the first row
                        if (rowNumber === 1) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Yellow background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                    
                        // Apply styles to rows containing "Total"
                        if (rowValues.some((value) => value.includes("Total"))) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light Salmon background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                    
                        // Apply styles to rows containing "Challan"
                        if (rowValues.some((value) => value.includes("Challan"))) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light Blue background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                    
                            // Apply styles to the row immediately below the "Challan" row
                            const nextRow = worksheet.getRow(rowNumber + 1);
                            nextRow.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light Green background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                            const nextRow2 = worksheet.getRow(rowNumber + 2);
                            nextRow2.eachCell((cell) => {
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                    });
                }
                else if(complianceReportType === "PF"){
                    worksheet.eachRow((row, rowNumber) => {
                        const rowValues = row.values.map(String); // Convert row values to strings for comparison
                     // Define a border style
                        const borderStyle = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' },
                        };
                        // Apply styles to the first row
                        if (rowNumber === 1) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Yellow background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                    
                        // Apply styles to rows containing "Total"
                        if (rowValues.some((value) => value.includes("Total"))) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light Salmon background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                    
                        // Apply styles to rows containing "Challan"
                        if (rowValues.some((value) => value.includes("Challan Summary"))) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light Blue background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                    
                            // Apply styles to the row immediately below the "Challan" row
                            const nextRow = worksheet.getRow(rowNumber + 1);
                            nextRow.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light Green background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                        if (rowValues.some((value) => value.includes("Total PF Applicable Employee Count"))) {
                            // Apply styles to the row immediately below the "Challan" row
                            const nextRow = worksheet.getRow(rowNumber + 1);
                            nextRow.eachCell((cell) => {
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                        if (rowValues.some((value) => value.includes("PF Exempted Employee Count"))) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light Blue background
                                };
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                            // Apply styles to the row immediately below the "Challan" row
                            const nextRow = worksheet.getRow(rowNumber + 1);
                            nextRow.eachCell((cell) => {
                                cell.font = { bold: true }; // Bold text
                                cell.border = borderStyle; 
                            });
                        }
                    });
                }
                else{
                    worksheet.eachRow((row, rowNumber) => {
                        const borderStyle = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' },
                        };
                        if (rowNumber === 1 || rowNumber === worksheet.rowCount) {
                            row.eachCell((cell) => {
                                cell.fill = {
                                    type: 'pattern',
                                    pattern: 'solid',
                                    fgColor: { argb: 'ffff99' }, // Light pink background
                                };
                                cell.font = { bold: true }; 
                                cell.border = borderStyle; 
                            });
                        }
                    });
                }
    
                // Adjust column widths
                worksheet.columns.forEach((column) => {
                    column.width = 20; // Adjust as needed
                });
    
                // Save the file
                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer]), `${company_code} ${complianceReportType} Report ${month}.xlsx`);
    
                Swal.close();
                Swal.fire({
                    title: `<strong>Success</strong>`,
                    text: message,
                    icon: 'success',
                    showConfirmButton: true,
                });
            } else {
                throw new Error(message || "Failed to generate the report.");
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: error.response ? error.response.message : error.message,
                icon: 'error',
                showConfirmButton: true,
            });
        } finally {
            setLoadingExport(false);
        }
    };
    
    
    const handleSelectAllDropdown = (action) => {
        if (action === 'select-all') {
            setSelectedRows(rows.map(row => row.employee_id));
        } else if (action === 'deselect-all') {
            setSelectedRows([]);
        }
    };

    const handleInputSearch = (e) => {
        setLoadingList(true);
        getList();
    }
    const handleFilter = (e) => {
        setLoadingFilter(true);
        getList();
    }

    const handleClearAll = () => {
        setFilter({
            keyword: null,
            month: null,
            location: null,
            department: null
        });
        setRows([]);
        setSelectedRows([]);
        // setIsChanged(true);
    }

    useEffect(() => {
        if (isChanged && filter?.month) {
            getList();
            setIsChanged(false);
        }
    }, [isChanged])

    const handlePrev = (ev) => {

        if (pagination?.prev === true) {
            // getList();
            setPagination({
                ...pagination,
                page: pagination?.page - 1
            });
            setIsChanged(true);
        }
    }
    const handleNext = () => {
        if (pagination?.next === true) {
            // getList();
            setPagination({
                ...pagination,
                page: pagination?.page + 1
            });
            setIsChanged(true);
        }
    }
    const handleChange = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value)
        });
        setIsChanged(true);
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value),
                page: 1,
            }
        );
        setIsChanged(true);
    };

    return (
        <div class="main-content" >
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Compliance Reports`} primary={`Home`} />

                    <div className="card">

                        <div className="card-body">
                            <div className="row mb-1">
                                {/* <div className='col-md-2'>
                                    <label> Select Month </label>
                                    <Select
                                        options={monthOptions}
                                        value={
                                            filter?.month
                                                ? monthOptions.find(option => option.value === filter?.month)
                                                : null
                                        }
                                        onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                        placeholder={`Select Month`} />
                                </div> */}
                                <div className='col-md-3'>
                                    <label htmlFor="keyword">Search By Name</label>
                                    <div className="input-group">
                                        <input type="search" className="form-control" onChange={handleInputChange} name="keyword" value={filter?.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Enter Name" />
                                        <button className="btn btn-success" onClick={handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                    </div>
                                </div>
                                <div className="col-md-3 position-relative ">
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label>Department</label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("department", selectedOptions)}
                                            placeholder={"All"}
                                            isMulti
                                            options={department}
                                            // isDisabled={!filter?.month}
                                            value={filter?.department ? filter?.department.split(',').map(id => department.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 position-relative ">
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" > Location </label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                                            placeholder={"All"}
                                            isMulti
                                            options={location}
                                            // isDisabled={!filter?.month}
                                            value={filter?.location ? filter?.location.split(',').map(id => location.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                </div>
                                <div className='col-md-3 position-relative'>
                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                        <label htmlFor="Location" className="form-label" > Select Month </label>
                                        <Select
                                            options={monthOptions}
                                            value={
                                                filter?.month
                                                    ? monthOptions.find(option => option.value === filter?.month)
                                                    : null
                                            }
                                            onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                            placeholder={`Select Month`} />
                                    </div>
                                </div>
                                
                            </div>
                            <div className=' d-flex align-items-center justify-content-between mb-3'>
                                <div className=' d-flex gap-3'>
                                    <div className=''>
                                        <div>
                                            <label>Apply Filter</label>
                                        </div>
                                        {!loadingFilter?
                                        (<button
                                            type="button"
                                            onClick={() => { handleFilter() }}
                                            disabled={loadingFilter || loadingExport}
                                            className={`${(!filter?.department && !filter?.location && !filter?.month) ? 'disabled' : ''}  btn btn-info btn-label waves-effect waves-light noWrap`}>
                                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                            {!loadingFilter ? "Filter" : "Loading..."}
                                        </button>) :
                                        (<button className="btn btn-info btn-load">
                                            <span className="d-flex align-items-center">
                                                <span style={{width: "1.2rem",height: "1.2rem",borderWidth: "2px",}} 
                                                    className="spinner-border flex-shrink-0" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </span>
                                                <span className="flex-grow-1 ms-2">
                                                    Loading...
                                                </span>
                                            </span>
                                        </button>)}
                                    </div>
                                    <div className=''>
                                        <div> <label>Clear Filter</label> </div>
                                        <button type="button"
                                            disabled={loadingFilter || loadingExport}
                                            className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!filter?.department && !filter?.location && !filter?.month) ? 'disabled' : ''}`}
                                            onClick={handleClearAll}
                                        >
                                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Clear</button>
                                    </div>
                                </div>
                                { decodedData?.includes(6) && ( 
                                <div className=' d-flex gap-3'>
                                    <div style={{ width: "15rem" }} className=' position-relative'>
                                        <div style={{ "zIndex": 9, "width": "100%" }} className=' position-absolute'>
                                            <label htmlFor="Location" className="form-label" >Select Report Type</label>
                                            <Select
                                                options={complianceReportOption}
                                                value={
                                                    complianceReportType
                                                        ? complianceReportOption.find(option => option.value === complianceReportType)
                                                        : null
                                                }
                                                onChange={(selectOption) => setComplianceReportType(selectOption?.value)}
                                                placeholder={`Select`} />
                                        </div>
                                    </div>
                                        { decodedData?.includes(6) && ( 
                                        <div style={{  }} className=''>
                                            <div>
                                                <label className=' noWrap'>Excel</label> 
                                            </div>
                                            {!loadingExport ?
                                                <button type="button"
                                                    disabled={ rows?.length === 0 || (selectedRows?.length === 0) || !filter?.month || !complianceReportType}
                                                    className={`btn noWrap btn-success btn-label waves-effect waves-light ${loadingExport ? 'disabled' : ''}`}
                                                    onClick={()=>{ setLoadingExport(true); handleExcelDownload()}}
                                                >
                                                    <i className=" ri-file-excel-2-line label-icon align-middle fs-16 me-2"></i> {!loadingExport ? "Download" : "Processing..."}</button> :
                                                <button className="btn btn-success btn-load">
                                                    <span className="d-flex align-items-center">
                                                        <span className="spinner-border flex-shrink-0" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </span>
                                                        <span className="flex-grow-1 ms-2">
                                                            Processing...
                                                        </span>
                                                    </span>
                                                </button>
                                            }
                                        </div>)}
                                </div>)}                                    
                            </div>
                            {loadingPayroll && (
                                <div
                                    id="myModal"
                                    className="modal show"
                                    tabIndex={-1}
                                    style={{
                                    display: "block",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    }}
                                    aria-labelledby="myModalLabel"
                                    aria-hidden="true"
                                >
                                    <div
                                    className=" h-100 d-flex justify-content-center align-items-center mt-3"
                                    style={{ width: "100%" }}
                                    >
                                    <div className="modal-content" style={{ width: "50%" }}>
                                        <div className="modal-body">
                                            <div className="card-body">
                                                <h3 className=' text-dark'>Payroll Process</h3>
                                                <h5 className=' mb-4'>{loadingPayroll ?
                                                    <span className="d-flex align-items-center">
                                                        <span  class="spinner-border flex-shrink-0"
                                                        role="status"
                                                        style={{
                                                        width: "1.2rem",
                                                        height: "1.2rem",
                                                        borderWidth: "2px",
                                                        }}>
                                                            <span className="visually-hidden">Loading...</span>
                                                        </span>
                                                        <span className="flex-grow-1 ms-2">
                                                        {uploadProgress == 100 ? 'Almost Completed...' :'Processing...'}
                                                        </span>
                                                    </span>:
                                                    'Completed'}
                                                </h5>
                                                <div className="progress animated-progress custom-progress progress-label mt-3">
                                                    <div
                                                        className="progress-bar bg-success"
                                                        role="progressbar"
                                                        style={{ width: `${uploadProgress}%` }}
                                                        aria-valuenow={uploadProgress}
                                                        aria-valuemin={0}
                                                        aria-valuemax={100}
                                                    >
                                                        <div className="label">{uploadProgress}%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            )}
                            <div className="">
                                <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                    <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ width: "100%" }}>
                                        <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                            <tr>
                                                {rows?.length > 0 ?
                                                    <th>
                                                        <div className=" d-flex gap-1 align-items-center justify-content-center" >
                                                            {/* <button type="button" className="border-0 "> */}
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input cursorPointer"
                                                                    disabled={loadingPayroll}
                                                                    checked={selectedRows.length === rows.length}
                                                                    onChange={handleSelectAll}
                                                                />
                                                            Select {selectedRows?.length>0 && <span className=' text-white'>({selectedRows?.length})</span>}

                                                        </div>
                                                    </th> : null
                                                }
                                                <th className='noWrap'>Employee Code</th>
                                                <th className='noWrap'>Employee Name</th>
                                                <th>Designation</th>
                                                <th>Department</th>
                                                <th>Location</th>
                                            </tr>
                                        </thead>
                                        {rows?.length === 0 ?
                                            <tbody>
                                                <td colSpan={5}>
                                                    <NoRecords />
                                                </td>
                                            </tbody> :
                                            <tbody>
                                                {rows?.map((row, idx) => (
                                                    <tr key={row.employee_id}>
                                                        <td>
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input cursorPointer"
                                                                    disabled={loadingPayroll}
                                                                    checked={selectedRows.some(val => val.employee_id === row?.employee_id)}
                                                                    onChange={() => handleCheckboxChange(row)}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>{row.employee_code}</td>
                                                        <td>{row.employee_name}</td>
                                                        <td>{row.designation_title}</td>
                                                        <td>{row.department_title}</td>
                                                        <td>{row.location_title}</td>


                                                    </tr>
                                                ))}
                                            </tbody>
                                        }
                                        {/* <tfoot className='table-light sticky-bottom z-1'>
                                            <tr>
                                                <th colSpan={8} >
                                                    <div className="d-flex justify-content-between" >
                                                        <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                            {
                                                                <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                                            }
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <select className="form-select" onChange={(e) => { handleChange(e) }}>
                                                                {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                                    <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <select
                                                                className="form-select"
                                                                onChange={handleLimitChange}
                                                                value={pagination?.limit}
                                                            >
                                                                {limitOptions.map((option) => (
                                                                    <option key={option} value={option}>
                                                                        Limit {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                    </div>
                                                </th>
                                            </tr>
                                        </tfoot> */}
                                    </table>
                                </div>
                                <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select className="form-select" onChange={(e) => handleChange(e)}>
                                            {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                            {pagination?.total_records >= 1 && (
                                                <option value={pagination?.total_records}>
                                                    All
                                                </option>
                                            )}
                                            {limitOptions?.map((option) => (
                                                <option key={option} value={option}>
                                                    Limit {option}
                                                </option>
                                            ))}
                                            
                                        </select>
                                    </div>
                                    <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                </div>
                            </div>
                            {processExcelExportModal && (
                                <div id="myModal" className="modal show" tabIndex={-1} style={{
                                    display: "block",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    }}
                                    aria-labelledby="myModalLabel"
                                    aria-hidden="true"
                                >
                                    <div
                                    className=" bg-light m-auto mt-3"
                                    style={{ width: "40%" }}
                                    >
                                    <div className="modal-content">
                                        <div
                                        style={{ padding: "10px 10px 0 10px" }}
                                        className="modal-header"
                                        >
                                            <h5 className="modal-title" id="myModalLabel">
                                                Attendance Process
                                            </h5>
                                            <button
                                                onClick={() => {
                                                setProcessExcelExportModal(false);
                                                }}
                                                className="btn-close"
                                                aria-label="Close"
                                            ></button>
                                        </div>
                                        <div className="modal-body">
                                            <div
                                                style={{ padding: "10px 0px 0 0px" }}
                                                className="card-body form-steps"
                                            >
                                                <div className='row'>
                                                    
                                                    
                                                </div>
                                                {/* handleAttendance */}
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                        
                                            {/* <button
                                                onClick={() => {
                                                    setProcessExcelExportModal(false)
                                                }}
                                                className="btn btn-light"
                                                >
                                                Close
                                            </button> */}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComplianceReports;
